var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmAirportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57751 8.66486H2.4842C2.33444 8.6649 2.20282 8.56558 2.16179 8.42155L1.01291 4.39981C0.962196 4.22179 1.06539 4.03637 1.2434 3.98566C1.2733 3.97714 1.30424 3.97282 1.33532 3.97283H11.1712C11.3563 3.97278 11.5063 4.12279 11.5064 4.30789C11.5064 4.33897 11.5021 4.36991 11.4936 4.39981L10.3447 8.42155C10.3037 8.56558 10.172 8.6649 10.0223 8.66486H7.92896M2.90181 3.97283V1.96196M9.60471 3.97283V1.96196M6.25326 3.97283V1.29167M8.59928 8.66486L10.5063 16.2921C10.551 16.4717 10.4418 16.6536 10.2622 16.6984C10.2357 16.705 10.2085 16.7083 10.1812 16.7083H2.32536C2.14027 16.7083 1.99026 16.5582 1.99031 16.3731C1.99032 16.3458 1.99366 16.3186 2.00027 16.2921L3.90725 8.66486M4.24239 5.31341V7.32428M8.26413 5.31341V7.32428M1.27299 5.31341H11.2335M1.84942 7.32428H10.657",
    stroke: "#AFB7C1",
    strokeWidth: 1.24407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmAirportIcon);
export default __webpack_public_path__ + "static/media/SMAirportIcon.233c9e2d.svg";
export { ForwardRef as ReactComponent };